// АНИМ.1: маппинг pathname → вариант перехода по умолчанию.
//
// Можно override через opts.variant в tx.navigate(to, opts).
// Auto-incoming listener (для legacy useNavigate) тоже использует это.

import type { TransitionVariant } from './types';

interface Rule {
  match: (p: string) => boolean;
  variant: TransitionVariant;
}

// КРИТИЧЕСКИ: проверяются по порядку — первое совпадение побеждает.
const RULES: Rule[] = [
  // Битва и матчмейкинг — heavy (это самый драматичный переход в игре)
  { match: (p) => p === '/battle' || p.startsWith('/tutorial-battle'), variant: 'heavy_glitch' },
  { match: (p) => p === '/pvp' || p === '/pvp/match', variant: 'heavy_glitch' },

  // Под-модалки и dev-страницы — soft (не тащить тяжёлый эффект, юзер
  // часто открывает/закрывает редактор колоды и магазин косметики).
  { match: (p) => p.startsWith('/decks/editor'), variant: 'soft' },
  { match: (p) => p.startsWith('/shop/cosmetic'), variant: 'soft' },
  { match: (p) => p === '/sandbox' || p.startsWith('/tutorial-demo'), variant: 'soft' }
];

const DEFAULT: TransitionVariant = 'glitch';

export function routeVariant(pathname: string): TransitionVariant {
  for (const rule of RULES) {
    if (rule.match(pathname)) return rule.variant;
  }
  return DEFAULT;
}
